export const secondsToMilliSeconds = (seconds: number) => seconds * 1000;
